var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper p-rel"},[_c(_vm.step.component,{tag:"component",attrs:{"context":_vm.context},on:{"state":_vm.onState}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }